import { createI18n } from "vue-i18n";
import { setTranslator } from "fw4-library";
import enLang from "@locales/en.json";
import siLang from "@locales/si.json";

const numberFormats = {
    'sl': {
      currency: {
        style: 'currency',
        currency: 'EUR',
      } as Intl.NumberFormatOptions,
      decimal: {
        style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2, useGrouping: true
      } as Intl.NumberFormatOptions,
      percent: {
        style: 'percent', useGrouping: false
      } as Intl.NumberFormatOptions,
    }
}

const messages = {
    en: {
        ...enLang,
    },
    sl: {
        ...siLang,        
    },    
};

export const i18n = createI18n({
    legacy: false,
    numberFormats,
    locale: "sl",
    messages,
    pluralRules: {
      
      'sl': function(choice: any, choicesLength: any) {
  
        switch(choice){
          case 0:
            return 0;
          case 1:
            return 1;
          case 2:
            return 2;
          case 3:
            return 3;
          case 4:
            return 4;
          default:
            return choicesLength - 1;
        }

      }
    }
})

setTranslator(i18n.global.t);
